import {SlotMath} from "slot-math";

export default class JapanMath extends SlotMath {

    constructor(config) {
        super(config);
    };

    checkScatterSymbol(combination, specialSymbol){

        let symbolPositions = [];

        if (specialSymbol === this.scatter) {

            for (let i = 0; i < this._reels; ++i) {
                let scatterPos = -1;
                let wildPos = -1;
                for (let j = i * this._rows; j < i * this._rows + this._rows; ++j) {
                    if (combination[j] === specialSymbol) {
                        scatterPos = j;
                    }
                    else if (combination[j] === this.wild) {
                        wildPos = j;
                    }
                }

                if (scatterPos >= 0) {
                    symbolPositions.push(scatterPos);
                }
                else if (wildPos >= 0) {
                    symbolPositions.push(wildPos);
                }
            }
        }
        else {
            for (let i = 0; i < combination.length; ++i) {
                if (combination[i] === specialSymbol) {
                    symbolPositions.push(i);
                }
            }
        }

        //console.log("SCATTER POSITION: ", symbolPositions);
        return (symbolPositions.length > 0) ? symbolPositions.slice() : symbolPositions;
    };

    // Определение наличия вайлда на колесе
    wildOnReel(reel) {
        let wildReel = false;
        for (let i=0; i<this._rows; i++ ){
            if (this._combination[reel*this._rows + i] === this._wildSymbol){
                wildReel = true;
            }
        }
        return wildReel;
    };

    /**
     * Parse line symbols combination - Japan specific algorithm
     * @param lineCombination {Number[]} Array of symbols on line
     * @returns {Object} Info object
     */
    // Метод переопределен т.к. вайлд считается при наличии вайлда в любой позиции на колесе
    parseRegularSymbols(lineCombination, wildSymbol, wildSymbolLineWinMultiplier, scatterSymbol, bonusSymbol) {

        wildSymbol = wildSymbol !== null ? wildSymbol : -1;
        wildSymbolLineWinMultiplier = wildSymbolLineWinMultiplier !== null ? wildSymbolLineWinMultiplier : 1;
        scatterSymbol = scatterSymbol !== null ? scatterSymbol : -1;
        bonusSymbol = bonusSymbol !== null ? bonusSymbol : -1;

        // символ с начала линии
        let currentSymbol = this.wildOnReel(0) ? wildSymbol : lineCombination[0];

        if (currentSymbol === scatterSymbol || currentSymbol === bonusSymbol) {
            return null;
        }

        let winSymbolIndex = [];

        winSymbolIndex.push(0);

        let combinationLength = 1;

        let hasWild = (currentSymbol === wildSymbol);

        var wildsCombinationLength = hasWild ? 1 : 0;

        for (let i = 1; i < lineCombination.length; ++i) {

            // текущий символ не изменился
            if (lineCombination[i] === currentSymbol || this.wildOnReel(i)/*( this.wildOnReel(i) && this.symbolSubstitutedByWild(lineCombination[i]) && currentSymbol == wildSymbol )*/) {

                if (currentSymbol === wildSymbol) {
                    wildsCombinationLength++;
                }

                combinationLength++;

                winSymbolIndex.push(i);
            }
            // текущий символ изменился
            else {

                // если цепочка прервана нелинейным символом
                if (lineCombination[i] === scatterSymbol ||
                    lineCombination[i] === bonusSymbol) {
                    // если оборвалась цепочка первоначально собранная из wild
                    if (currentSymbol === wildSymbol) {
                        hasWild = false;
                    }

                    break;
                }

                // если оборвалась цепочка первоначально собранная из wild
                if (currentSymbol === wildSymbol) {
                    // дальше может быть обычный (не scatter) символ или символ заменяется на wild на одном барабане с ним и потом могут быть опять wild

                    let symbol = lineCombination[i];

                    combinationLength++;

                    winSymbolIndex.push(i);
                    // сканируем тут до конца линиии и ищем или symbol или wild - любой другой символ заканчивает комбинацию

                    for (let j = i + 1; j < lineCombination.length; ++j) {

                        if (lineCombination[j] === symbol || this.wildOnReel(j)) {
                            combinationLength++;
                            winSymbolIndex.push(j);
                        }
                        else {

                            break;
                        }
                    }
                    if (this.price(wildSymbol, wildsCombinationLength) >= this.price(symbol, combinationLength) * (hasWild ? wildSymbolLineWinMultiplier : 1)) {

                        if (wildsCombinationLength < combinationLength) {
                            winSymbolIndex = winSymbolIndex.splice(0, wildsCombinationLength);
                        }

                        combinationLength = wildsCombinationLength;
                        // специально отмечаем чтобы выигрыш за комбинацию только из wild не умножать на специальный множитель
                        hasWild = false;
                    }
                    else {
                        currentSymbol = symbol;
                    }

                    break;
                }
                // цепочка была из обычных символов и попался wild
                else {

                    if (this.wildOnReel(i)) {

                        hasWild = true;
                        combinationLength++;
                        winSymbolIndex.push(i);
                    }
                    //  цепочка прервалась (попался другой символ и не wild)
                    else {
                        break;
                    }
                }
            }
        }
        if (this.price(currentSymbol, combinationLength) === 0) {
            return null;
        }

        // определяем есть ли вайд символ на барабане
        for (let i = 0; i < this._reels/*combinationLength*/; ++i) {
            if (this.wildOnReel(i)){
                hasWild = true;
            }
        }

        let lineWin = 0;

        if (currentSymbol === this._wildSymbol){
            lineWin = this.price(currentSymbol, combinationLength);
        }
        else {
            lineWin = this.price(currentSymbol, combinationLength) * (hasWild ? this._wildSymbolLineWinMultiplier : 1);
        }

        return {
            winSymbol: currentSymbol,
            winSymbolIndex:winSymbolIndex,
            combinationLength: combinationLength,
            hasWild: hasWild,
            win: lineWin
        };
    };
}


// WEBPACK FOOTER //
// ./src/japan_math.es6